import { render } from "./LikertIconsScale.vue?vue&type=template&id=da9f72f0&scoped=true"
import script from "./LikertIconsScale.vue?vue&type=script&lang=js"
export * from "./LikertIconsScale.vue?vue&type=script&lang=js"

import "./LikertIconsScale.vue?vue&type=style&index=0&id=da9f72f0&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9f72f0"]])

export default __exports__